import React, {PropTypes} from 'react';
import Lightbox from 'react-images';
class LightBox extends React.Component {

    constructor(props) {
      super(props);
      this.state = {
        lightboxIsOpen: props.open,
        currentImage: 0,
      };
      this.closeLightbox = this.closeLightbox.bind(this);
      this.gotoNext = this.gotoNext.bind(this);
      this.gotoPrevious = this.gotoPrevious.bind(this);
      this.gotoImage = this.gotoImage.bind(this);
      this.handleClickImage = this.handleClickImage.bind(this);
      this.openLightbox = this.openLightbox.bind(this);
    }

  openLightbox (index, event) {
    event.preventDefault();
    this.setState({
      currentImage: index,
      lightboxIsOpen: true,
    });
  }
  closeLightbox () {
  this.props.close();
  }
  gotoPrevious () {
    this.setState({
      currentImage: this.state.currentImage - 1,
    });
  }
  gotoNext () {
    this.setState({
      currentImage: this.state.currentImage + 1,
    });
  }
  gotoImage (index) {
    this.setState({
      currentImage: index,
    });
  }
  handleClickImage () {
    if (this.state.currentImage === this.props.images.length - 1) return;

    this.gotoNext();
  }

    render() {
        return (
          <div>
            <Lightbox
              currentImage={this.state.currentImage}
              images={this.props.images}
              isOpen={this.props.open}
              onClickImage={this.handleClickImage}
              onClickNext={this.gotoNext}
              onClickPrev={this.gotoPrevious}
              onClickThumbnail={this.gotoImage}
              onClose={this.closeLightbox}
              showThumbnails={true}

            />

          </div>
        );
    }
}

LightBox.propTypes = {};

export default LightBox;





/** WEBPACK FOOTER **
 ** ./src/components/LightBox.js
 **/